import { render, staticRenderFns } from "./mainImage.vue?vue&type=template&id=5ed95a6e&scoped=true"
import script from "./mainImage.vue?vue&type=script&lang=js"
export * from "./mainImage.vue?vue&type=script&lang=js"
import style0 from "./mainImage.vue?vue&type=style&index=0&id=5ed95a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed95a6e",
  null
  
)

export default component.exports